import './scss/app.scss'

import Vue from 'vue'
import App from '@/vue/App'
import Vuelidate from 'vuelidate'
import VueResource from 'vue-resource'
import VueHead from 'vue-head'
import log from 'loglevel'
import config from './config'
import NProgress from 'nprogress'
import moment from 'moment'
import router from '@/vue-router'

import { buildStore, vuexTypes } from '@/vuex'
import { tableScrollShadow } from '@/vue/directives/tableScrollShadow'
import { vueAuthImageDirective } from '@/vue/directives/auth-image'
import { ripple } from '@/vue/directives/ripple'
import { antPortal } from '@/vue/directives/portalDirective'
import { i18n } from '@/i18n'
import { globalize } from '@/vue/filters/globalize'
import { formatDate } from '@/vue/filters/formatDate'
import { formatMoney } from '@/vue/filters/formatMoney'
import { formatNumber } from '@/vue/filters/formatNumber'
import { formatInteger } from '@/vue/filters/formatInteger'
import { formatPercent } from '@/vue/filters/formatPercent'
import { formatCalendar } from '@/vue/filters/formatCalendar'
import { formatCalendarInline } from '@/vue/filters/formatCalendarInline'
import { formatDateDMY } from '@/vue/filters/formatDateDMY'
import { formatDateDMYT } from '@/vue/filters/formatDateDMYT'
import { abbreviate } from '@/vue/filters/abbreviate'
import { readableCamelCase } from '@/vue/filters/readableCamelCase'
import { readableSnakeCase } from '@/vue/filters/readableSnakeCase'
import { formatCommonAbbreviations } from '@/vue/filters/formatCommonAbbreviations'
import { formatUserRole } from '@/vue/filters/formatUserRole'
import { formatVerificationStatus } from '@/vue/filters/formatVerificationStatus'
import { formatVerificationType } from '@/vue/filters/formatVerificationType'
import { formatVerificationSubtype } from '@/vue/filters/formatVerificationSubtype'
import { cropAddress } from '@/vue/filters/cropAddress'
import { ErrorTracker } from '@/js/helpers/error-tracker'
import { vueRoutes } from './vue-router/routes'
import { useBrowserUpdateBanner } from './browser-update'
import { initApi } from './api'
import VueClipboard from 'vue-clipboard2'

async function init () {
  useBrowserUpdateBanner(Vue)

  await initApi()

  i18n.onLanguageChanged(lang => moment.locale(lang))
  await i18n.init()

  log.setDefaultLevel(config.LOG_LEVEL)

  Vue.config.devtools = process.env.NODE_ENV === 'development'
  Vue.config.productionTip = false
  Vue.use(Vuelidate)
  Vue.use(VueResource)
  Vue.use(VueClipboard)
  Vue.use(VueHead)

  Vue.directive('auth-image', vueAuthImageDirective)
  Vue.directive('table-scroll-shadow', tableScrollShadow)
  Vue.directive('ripple', ripple)
  Vue.directive('ant-portal', antPortal)

  Vue.filter('globalize', globalize)
  Vue.filter('formatDate', formatDate)
  Vue.filter('formatDateDMY', formatDateDMY)
  Vue.filter('formatDateDMYT', formatDateDMYT)
  Vue.filter('formatMoney', formatMoney)
  Vue.filter('formatNumber', formatNumber)
  Vue.filter('formatPercent', formatPercent)
  Vue.filter('formatInteger', formatInteger)
  Vue.filter('formatCalendar', formatCalendar)
  Vue.filter('formatCalendarInline', formatCalendarInline)
  Vue.filter('abbreviate', abbreviate)
  Vue.filter('cropAddress', cropAddress)
  Vue.filter('readableCamelCase', readableCamelCase)
  Vue.filter('readableSnakeCase', readableSnakeCase)
  Vue.filter('formatCommonAbbreviations', formatCommonAbbreviations)
  Vue.filter('formatUserRole', formatUserRole)
  Vue.filter('formatVerificationStatus', formatVerificationStatus)
  Vue.filter('formatVerificationType', formatVerificationType)
  Vue.filter('formatVerificationSubtype', formatVerificationSubtype)
  Vue.prototype.$config = config
  Vue.prototype.$routes = vueRoutes

  const store = buildStore()

  if (store.getters[vuexTypes.isLoggedIn]) {
    store.dispatch(vuexTypes.LOAD_ACCOUNT)
  }

  router.beforeEach((to, from, next) => {
    if (to.name !== from.name) {
      NProgress.start()
    }
    next()
  })

  NProgress.configure({ showSpinner: false })
  router.afterEach((to, from) => {
    NProgress.done()
  })

  ErrorTracker.init(config)

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>',
  })
}

init()
